export const housekeepingDrawer = {
  close: "Schließen",
  guest: "Gast",

  cleaning: {
    title: "Reinigungsstatus",
    lastCleaned: "Gereinigt {date}",
    evidenceAlt: "Nachweis",
  },

  status: {
    dirty: "Zu reinigen",
    in_progress: "In Arbeit",
    clean: "Sauber",
    inspected: "Geprüft",
    out_of_service: "Außer Betrieb",
  },

  occupancy: {
    title: "Belegung",
    aboutToLeave: "Reist gleich ab",
    checkIn: "Check-in {date}",
    checkOut: "Check-out {date}",
    checkoutTime: "Check-out {time}",
    booking: "Buchung {code}",
    nextArrivalToday: "Nächste Anreise heute",
    fromTime: "ab {time}",
    labels: {
      vacant: "Frei",
      occupied: "Belegt",
      departure_today: "Reist heute ab",
      arrival_today: "Reist heute an",
      turnover: "Abreise und Anreise heute",
    },
  },

  window: {
    windowLabel: "Zeitfenster",
    standardSchedule: "Standardzeiten",
    sub: "{label}: Check-out {checkout} → Check-in {checkin}",
    overdue: "Anreise überfällig · diese Reinigung vorziehen",
    untilArrival: "{dur} bis zur Anreise",
  },

  tasks: {
    title: "Reinigungsaufgaben",
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of open tasks
    pendingCount: "{count} offen | {count} offen",
    newPlaceholder: "Aufgabe hinzufügen (z. B. Handtücher wechseln)",
    priorityTitle: "Priorität",
    dateTitle: "Datum",
    timeTitle: "Uhrzeit (optional)",
    assignTitle: "Zuweisen an",
    assignAllOption: "Alle (Reinigung und Wartung)",
    byRole: "Nach Rolle",
    wholeRoleSuffix: "(gesamte Rolle)",
    people: "Personen",
    add: "Hinzufügen",
    adding: "Wird hinzugefügt…",
    loading: "Aufgaben werden geladen…",
    empty: "Keine Aufgaben. Fügen Sie oben die erste hinzu.",
    markPending: "Als offen markieren",
    markDone: "Als erledigt markieren",
    priorityDotTitle: "Priorität {priority}",
    delete: "Löschen",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Niedrig",
    normal: "Normal",
    high: "Hoch",
    urgent: "Dringend",
  },

  roles: {
    limpieza: "Reinigung",
    mantenimiento: "Wartung",
    propietario: "Eigentümer",
  },

  assignee: {
    assigned: "Zugewiesen",
    all: "Alle",
  },
};
